import {useTranslation} from "next-i18next";
import WhyUsCard from "./WhyUsCard";

const Why = ({...props}) => {
  const {t} = useTranslation(["index", "common"]);
  const whyItems = t("index:why", {returnObjects: true})

  return (
    <div {...props} className="why grid_background">
      <h2 className="why__title">{t("common:why.title")}</h2>
      <div className="why__container">
        {
          whyItems.map((item) => <WhyUsCard key={item.title} image={item.image} description={item.description} title={item.title}/>)
        }
      </div>
    </div>
  );
};

Why.propTypes = {};

export default Why;
